export default () => ({
  user: null,
  settings: null,
})
